var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalIncome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFB177;}\r\n\t.st1{fill:#545C66;}\r\n\t.st2{fill:#CCD1D9;}\r\n\t.st3{fill:#4A89DC;}\r\n\t.st4{fill:#5D9CEC;}\r\n\t.st5{fill:#E6E9ED;}\r\n\t.st6{fill:#402C1E;}\r\n\t.st7{fill:#EAC6BB;}\r\n\t.st8{fill:#D3B1A9;}\r\n\t.st9{fill:#48CFAD;}\r\n\t.st10{fill:#37BC9B;}\r\n\t.st11{fill:#656D78;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1000,
    cy: 1000,
    r: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1165.8,676.5c-8.7,0-15.8-7.1-15.8-15.8v-63.3c0-8.7,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8v63.3 C1181.5,669.4,1174.5,676.5,1165.8,676.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1371,676.5c-8.7,0-15.8-7.1-15.8-15.8v-63.3c0-8.7,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8v63.3 C1386.8,669.4,1379.7,676.5,1371,676.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1268.4,1102.5c-8.7,0-15.8-7.1-15.8-15.8v-47.2c0-8.7,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8v47.2 C1284.1,1095.5,1277.1,1102.5,1268.4,1102.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1268.4,1307.9c-8.7,0-15.8-7.1-15.8-15.8v-94.7c0-8.7,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8v94.7 C1284.1,1300.9,1277.1,1307.9,1268.4,1307.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1205.2,1371.1c-8.7,0-15.8-7.1-15.8-15.8c0-8.7,7.1-15.8,15.8-15.8c26.1,0,47.4-21.2,47.4-47.4 c0-8.7,7.1-15.8,15.8-15.8c8.7,0,15.8,7.1,15.8,15.8C1284.1,1335.7,1248.7,1371.1,1205.2,1371.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1205.2,1371.1h-134.2c-8.7,0-15.8-7.1-15.8-15.8c0-8.7,7.1-15.8,15.8-15.8h134.2c8.7,0,15.8,7.1,15.8,15.8 C1221,1364,1213.9,1371.1,1205.2,1371.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1418.3,850v142.1l-48,47.4h-102h-102.6l-47.4-47.4V850L1418.3,850z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1418.3,660.7V850h-299.9V660.7h47.4H1371H1418.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1007.9,771.1v94.7l-63.1-63.1c0,0-72.1,31.6-157.9,31.6s-157.9-31.6-157.9-31.6l-63.1,63v-78.8 c0-104.8,84.8-189.4,189.4-189.4h157.9v78.9C965.6,676.4,1007.9,718.7,1007.9,771.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1007.9,865.8v-94.7c0-52.4-42.3-94.7-94.7-94.7v-78.9h-63.1v78.9c0,34.9,28.3,63.1,63.1,63.1 c17.4,0,31.6,14.1,31.6,31.6v31.6L1007.9,865.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M881.6,1144.4v68.7l-94.7,126.4l-94.7-126.4v-68.7c28.7,13.7,60.9,21.3,94.7,21.3S852.9,1158.1,881.6,1144.4 L881.6,1144.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1007.9,865.8v78.9c0,88.1-51.6,164.2-126.3,199.7c-28.7,13.7-60.9,21.3-94.7,21.3s-66-7.6-94.7-21.3 c-74.7-35.5-126.3-111.6-126.3-199.7v-0.5v-78.6l63.1-63c0,0,72.1,31.6,157.9,31.6s157.9-31.6,157.9-31.6L1007.9,865.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M944.8,802.6L944.8,802.6l-0.1,142.1c0,88.1-51.6,164.2-126.3,199.7c-19.6,9.4-40.9,15.6-63.1,18.8 c10.4,1.5,20.9,2.5,31.6,2.5c33.8,0,66-7.6,94.7-21.3c74.7-35.5,126.3-111.6,126.3-199.7v-78.9L944.8,802.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1071.1,1355.3v62.8H502.8v-92.3v-2.2c0-61.1,49.4-110.5,110.5-110.5h78.9l94.7,126.4l94.7-126.4h78.9 c61.1,0,110.5,49.4,110.5,110.5v2.2V1355.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M960.6,1213.1h-63.2c61.1,0,110.5,49.4,110.5,110.5v2.2v29.5v62.8h63.2v-62.8v-29.5v-2.2 C1071.1,1262.5,1021.6,1213.1,960.6,1213.1L960.6,1213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1481.4,613.2H1071c-8.7,0-15.8-7.1-15.8-15.8c0-8.7,7.1-15.8,15.8-15.8h410.4c8.7,0,15.8,7.1,15.8,15.8 C1497.2,606.2,1490.2,613.2,1481.4,613.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1370.3,1055.2h-204.6c-4.2,0-8.2-1.7-11.2-4.6l-47.4-47.4c-3-3-4.6-7-4.6-11.2V660.7 c0-8.7,7.1-15.8,15.8-15.8h299.9c8.7,0,15.8,7.1,15.8,15.8V992c0,4.2-1.7,8.3-4.7,11.3l-48,47.4 C1378.4,1053.6,1374.5,1055.2,1370.3,1055.2z M1172.3,1023.6h191.5l38.7-38.2V676.5h-268.4v309L1172.3,1023.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1481.4,581.6c-8.7,0-15.8,7.1-15.8,15.8v821h31.6v-821C1497.2,588.7,1490.2,581.6,1481.4,581.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1299.9,1181.7c0,8.7-7.1,15.8-15.8,15.8h-31.6c-8.7,0-15.8-7.1-15.8-15.8v-78.9c0-8.7,7.1-15.8,15.8-15.8 h31.6c8.7,0,15.8,7.1,15.8,15.8V1181.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1284.2,1086.9h-15.8h-15.8c-8.7,0-15.8,7.1-15.8,15.8v31.6h63.1v-31.6 C1299.9,1094.1,1292.8,1086.9,1284.2,1086.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIncome);
export default __webpack_public_path__ + "static/media/total-income.85034ea776c88bed297158c7da52d50b.svg";
export { ForwardRef as ReactComponent };